<form [formGroup]="formGroup" (ngSubmit)="submit()" autocomplete="off" formName="RloApplicationSortForm">
  <div class="header">
    <div class="primary-header">
      <fpx-button className="back" btnType="button" label="Back" (onClick)="_helper.closeSort()"></fpx-button>
      <div class="title">Sort</div>
    </div>

    <fpx-button className="close" btnType="button" (onClick)="_helper.closeSort()"></fpx-button>

  </div>
  <box class="entry-form">

    <fpx-fieldset class="checkBoxGroup">
      <app-application-sort-arn-control class="col-md-4" formControlName="arn" label="ARN"
        placeholder="Select"></app-application-sort-arn-control>

      <app-application-sort-arn-control class="col-md-4" formControlName="applicantName" label="Applicant Name"
        placeholder="Select"></app-application-sort-arn-control>
      <app-rlo-sort-filter-control class="col-md-4" formControlName="period" label="Period"
        placeholder="Select"></app-rlo-sort-filter-control>
      <app-rlo-sort-filter-control class="col-md-4" formControlName="tat" label="TAT Overdue"
        placeholder="Select"></app-rlo-sort-filter-control>

      <app-application-sort-arn-control class="col-md-4" formControlName="stage" label="Stage"
        placeholder="Select"></app-application-sort-arn-control>

      <app-rlo-sort-filter-control class="col-md-4" formControlName="type" label="Priority"
        placeholder="Select"></app-rlo-sort-filter-control>
    </fpx-fieldset>

  </box>
  <footer class="form-actions">
    <fpx-button className="secondary" btnType="button" label="Clear" (onClick)="_helper.clearSort()"></fpx-button>
    <fpx-button [disable]="this.rloapplicationService.sortApplied" className="primary" btnType="button" (onClick)="_helper.applySort()" label="Apply"></fpx-button>
  </footer>
</form>
